import { render, staticRenderFns } from "./PageViewCellRendererActions.vue?vue&type=template&id=610bdb7c&scoped=true&"
import script from "./PageViewCellRendererActions.vue?vue&type=script&lang=js&"
export * from "./PageViewCellRendererActions.vue?vue&type=script&lang=js&"
import style0 from "./PageViewCellRendererActions.vue?vue&type=style&index=0&id=610bdb7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610bdb7c",
  null
  
)

export default component.exports